/* eslint-disable @typescript-eslint/no-shadow,@typescript-eslint/no-unused-expressions,prefer-destructuring, no-var,vars-on-top */

import { EVENTS } from '../../../../app/constants/events';
import { DESIGNER_EVENTS } from '../../../../app/constants/designer_events';

xplenty.controller('ComponentEditorSourceController', [
  '$scope',
  '$rootScope',
  '$timeout',
  '$translate',
  '$controller',

  function ($scope, $rootScope, $timeout, $translate, $controller) {
    $scope.isNew = $scope.component.connection.id === null;
    $scope.saved = true;
    $scope.sourceComponentId = $scope.component.id;
    $scope.selectedFields = _.clone($scope.component.schema.fields);

    angular.extend(this, $controller('ConnectionStep', { $scope }));
    angular.extend(this, $controller('ComponentFormStep', { $scope }));
    angular.extend(this, $controller('SchemaImporterStep', { $scope }));

    const isComponentValid = function () {
      $timeout(function () {
        const isComponentValid =
          $scope.componentNameValid &&
          $scope.connectionStep.validate() &&
          $scope.componentFormStep.validate() &&
          $scope.schemaImporterStep.validate();

        $rootScope.$broadcast(EVENTS.DESIGNER_COMPONENT_SAVE_DISABLE, !isComponentValid);
        $rootScope.$broadcast(EVENTS.DATA_PREVIEW_DISABLED, !isComponentValid);
      });
    };

    var init = function () {
      let timeoutPromise;

      $scope.$watch(
        'component',
        function () {
          timeoutPromise && $timeout.cancel(timeoutPromise);
          timeoutPromise = $timeout(function () {
            isComponentValid();
            timeoutPromise = null;
          }, 100);
        },
        true,
      );

      $scope.$watch(
        'schemaImporterStep',
        function (newSchemaImporterStep, oldSchemaImporterStep) {
          if (
            newSchemaImporterStep.active &&
            !oldSchemaImporterStep.active &&
            $scope.connectionStep.valid &&
            $scope.componentFormStep.valid &&
            $scope.componentFormStep.isChanged()
          ) {
            $rootScope.$broadcast(EVENTS.SCHEMA_IMPORTER_GET_SCHEMA, $scope.component.disableSchemaLoad);
          }
          if (newSchemaImporterStep.active && !oldSchemaImporterStep.active) {
            $rootScope.$broadcast(EVENTS.SCHEMA_IMPORTER_REFRESH);
          }
          isComponentValid();
        },
        true,
      );
    };

    const setRelevantStep = function () {
      $scope.connectionStep.active = true;

      init();
    };

    $timeout(setRelevantStep);

    // GETTING PARENT SCHEMAS
    $scope.$on(DESIGNER_EVENTS.COMPONENT_RETURN_PARENT_SCHEMA, function (event, schemas) {
      $scope.schemas = schemas;
      if (!$scope.component.schema && schemas.length === 1) {
        $scope.component.schema = schemas[0];
      }
      if (schemas.length > 0) $scope.schemaFields = schemas[0].fields;
      if (schemas.length > 1) $scope.schemaFields2 = schemas[1].fields;
    });

    $rootScope.$broadcast(DESIGNER_EVENTS.COMPONENT_GET_PARENT_SCHEMA, $scope.component.id);
  },
]);
